var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1885",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5596",
    "data-name": "Group 5596",
    transform: "translate(-435 -533)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 435, 533)",
    filter: "url(#Path_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885-2",
    "data-name": "Path 1885",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock-1-svgrepo-com",
    transform: "translate(460.897 552.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M151.095,96.2H139.3a5.9,5.9,0,0,1-5.9-5.9V81.448a5.911,5.911,0,0,1,4.425-5.712V72.6a5.9,5.9,0,0,1,5.9-5.9h2.951a5.9,5.9,0,0,1,5.9,5.9v3.137A5.911,5.911,0,0,1,157,81.448V90.3A5.906,5.906,0,0,1,151.095,96.2ZM139.3,78.5a2.953,2.953,0,0,0-2.951,2.951V90.3a2.953,2.953,0,0,0,2.951,2.951h11.8A2.953,2.953,0,0,0,154.05,90.3V81.448A2.953,2.953,0,0,0,151.1,78.5Zm1.473-2.947h8.849V72.6a2.953,2.953,0,0,0-2.951-2.951h-2.951a2.953,2.953,0,0,0-2.951,2.951v2.951ZM145.2,90.3a1.473,1.473,0,0,1-1.473-1.473V86.952a2.951,2.951,0,1,1,2.956,0v1.872A1.486,1.486,0,0,1,145.2,90.3Z",
    transform: "translate(-133.4 -66.7)",
    fill: "#ff3535"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityLock);
export default __webpack_public_path__ + "static/media/securityLock.1e2b5a1685efba98d3f6e4a3a7e173d4.svg";
export { ForwardRef as ReactComponent };